<template>
  <div class="yxtbiz-doc-player" :class="{ 'yxtbiz-doc-player--dark': dark }">
    <component ref="viewer" :is="componentName" v-bind="_props">
      <yxtbiz-watermark slot="watermark" :version="watermarkCode ? 'v2':''" :app-code="this.watermarkCode" :option="watermarkConfig"/>
    </component>
    <toolbar :dark.sync="dark" 
             :fullscreen="fullscreen"
             :zoom.sync="zoom"
             :toolbars="toolbars"
             @pageChange="onPageChange"
             @scrollToPage="scrollToPage"
             @toggleFullScreen="toggleFullScreen">
      <slot name="operation"></slot>
    </toolbar>
  </div>
</template>

<script>
import screenfull from 'screenfull';
import PictureViewer from './components/picture-viewer.vue';
import TencentViewer from './components/tencent-viewer.vue';
import Toolbar from './components/toolbar.vue';
import propsMixins from './mixins/props';
export default {
  components: { PictureViewer, TencentViewer, Toolbar },
  name: 'YxtbizDocPlayer',
  mixins: [propsMixins],
  provide() {
    return {
      getZoom: () => this.zoom,
      getMode: () => this.mode
    };
  },
  props: {
    mode: { // 播放模式 图片模式 html模式
      type: String,
      default: 'picture' // picture html
    },
    toolbars: {
      type: Array,
      default: () => ['moon', 'zoom', 'fullscreen']
    }
  },
  data() {
    return {
      dark: false,
      fullscreen: false,
      zoom: 0
    };
  },
  computed: {
    componentName() {
      if (this.mode === 'html') return 'TencentViewer';
      return 'PictureViewer';
    }
  },
  mounted() {
    this.$el.addEventListener('contextmenu', this.contextmenu);
  },
  beforeDestroy() {
    this.$el.removeEventListener('contextmenu', this.contextmenu);
  },
  methods: {
    contextmenu(e) {
      e.preventDefault();
    },
    scrollToPage(page) {
      this.$refs.viewer && this.$refs.viewer.scrollToPage && this.$refs.viewer.scrollToPage(page);
    },
    toggleFullScreen() {
      this.fullscreen = !this.fullscreen;
      this.zoom = 0;
      if (this.fullscreen) {
        screenfull.request(this.$el);
      } else {
        screenfull.exit();
      }
      this.onFullscreenChange(this.fullscreen);
    },
    onPageChange(page) {
      this.$emit('pageChange', page);
    },
    onFullscreenChange(val) {
      this.$emit('fullscreenChange', val);
    }
  }
};
</script>
